"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ENCOUNTER_PRESCRIPTION_GENERIC_NAMES_MAX () {
        return ENCOUNTER_PRESCRIPTION_GENERIC_NAMES_MAX;
    },
    get EncounterPrescriptionListItemSchema () {
        return EncounterPrescriptionListItemSchema;
    },
    get EncounterPrescriptionListResponseSchema () {
        return EncounterPrescriptionListResponseSchema;
    }
});
const _zod = require("zod");
const _prescriptionstatus = require("./prescription-status");
const _prescriptiontext = require("./prescription-text");
const ENCOUNTER_PRESCRIPTION_GENERIC_NAMES_MAX = 3;
const EncounterPrescriptionListItemSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    status: _prescriptionstatus.PrescriptionStatusSchema,
    rxNo: _zod.z.string().nullable(),
    itemCount: _zod.z.number().int().min(0).max(_prescriptionstatus.PRESCRIPTION_LIMITS.itemsMax),
    /** The first lines' generic names, in position order. */ genericNames: _zod.z.array(_zod.z.string()).max(ENCOUNTER_PRESCRIPTION_GENERIC_NAMES_MAX),
    issuedAt: (0, _prescriptiontext.isoDateTime)().nullable(),
    updatedAt: (0, _prescriptiontext.isoDateTime)()
}).strict();
const EncounterPrescriptionListResponseSchema = _zod.z.object({
    items: _zod.z.array(EncounterPrescriptionListItemSchema),
    total: _zod.z.number().int().min(0)
}).strict();
